import * as React from "react"

import * as st from './Greeting.styled.js'

const Greeting = () => (
  <st.Wrap>
      <st.Title>
        Modern customer <ins>onboarding platform</ins> for B2B companies
      </st.Title>
      <st.Description>
        Powerful AI-driven platform to accelerate onboarding cycles, automate workflows, boost customer engagement, and significantly improve team efficiency
      </st.Description>
      <st.Actions>
        <st.BookButton
          type="a"
          view="primary"
          size={700}
          href="https://cal.com/scope/demo"
        >
          Book a Demo
        </st.BookButton>
      </st.Actions>
  </st.Wrap>
)

export default Greeting
